var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../api/axios";
import { AccountRoutesType } from "../../Shared/components/Navigation/navigationUtils";
import { AUTH_METHOD_EMAIL, LoginRegisterText } from "../LoginRegister-types";
import { updateCartCustomer } from "../../Account/utils/requests";
import logRocketLauncher from "../../Shared/utils/logRocketLauncher";
export const loginCustomer = (email, password, rememberMe) => {
    return axiosPrivate.post("/Login", { Email: email, Password: password, RememberMe: rememberMe });
};
export const forgotPassword = (email) => {
    return axiosPrivate.post("/ForgotPassword", { email: email });
};
/**
 * Track a successful customer login.
 *
 * Checkout is auth-gated, so without the GA4 login event a customer who stops at
 * the auth wall is indistinguishable from an ordinary cart abandoner.
 */
export const loginEvent = (createKlaviyoEvent, gaEvent) => () => {
    // TODO: this reports a returning customer's login to Klaviyo as CompleteRegistration,
    // which likely inflates registration counts and blurs new signups against repeat
    // logins. Left in place because correcting it changes existing Klaviyo reporting, so
    // it needs marketing sign-off rather than a silent fix.
    createKlaviyoEvent("CompleteRegistration");
    //Klaviyo requires a customer so PageView must be tracked after logging in
    createKlaviyoEvent("PageView", {
        SelectedLocation: "Login",
    });
    gaEvent("login", { method: AUTH_METHOD_EMAIL });
};
export const handleLoginFormSubmit = (setError, setLoading, navigate, location, loginEvent, setIsAuthenticated, isLogRocketEnabled) => (data) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    setLoading(true);
    const res = yield loginCustomer(data.email, data.password, data.rememberMe);
    if (res.data.success) {
        updateCartCustomer();
        if (isLogRocketEnabled === true) {
            logRocketLauncher.login();
        }
        loginEvent();
        setIsAuthenticated(true);
        localStorage.setItem("mt-customer", "true");
        const nextRoute = (_b = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.prevRoute) !== null && _b !== void 0 ? _b : AccountRoutesType.ORDERS;
        navigate(nextRoute, { state: Object.assign({}, location.state), replace: true });
    }
    if (!res.data.success) {
        setError("password", { message: res.data.responseMsg });
        setLoading(false);
    }
});
export const handleForgotPassword = (setError, setLoading, clearErrors, trigger, toast, email) => __awaiter(void 0, void 0, void 0, function* () {
    clearErrors("email");
    const triggerRes = yield trigger("email", { shouldFocus: true });
    if (email === "" || !triggerRes) {
        setError("email", { type: "validate", message: LoginRegisterText.FORGOT_PASSWORD_EMAIL_REQUIRED });
        return;
    }
    setLoading(true);
    const res = yield forgotPassword(email);
    toast.push(res.data.responseMsg, { variant: res.data.success ? "success" : "error" });
    setLoading(false);
});
